import { render } from "./ReserVasiPayment.vue?vue&type=template&id=875dc894"
import script from "./ReserVasiPayment.vue?vue&type=script&lang=js"
export * from "./ReserVasiPayment.vue?vue&type=script&lang=js"

import "./ReserVasiPayment.vue?vue&type=style&index=0&id=875dc894&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__